// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const spendeFuerDieStiftungFuerKrebskrankeKinderCoburgDE: PageEntry = {
  id: "post.spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg",
  locale: "de",
  slug: "spende-fuer-die-stiftung-fuer-krebskranke-kinder-coburg",
  seo: {
    title: "Spende für die Stiftung für krebskranke Kinder Coburg | Dietz GmbH",
    description: "Spende für die Stiftung für krebskranke Kinder Coburg",
  },
  type: "post",
  h1: "Spende für die Stiftung für krebskranke Kinder Coburg",
  blocks: [
    { kind: "heading", level: 2, text: "Spende für die Stiftung für krebskranke Kinder Coburg" },
    { kind: "paragraph", text: "Im Rahmen unseres Betriebsjubiläums haben wir einen Spendenaufruf für die Stiftung für krebskranke Kinder Coburg gestartet. Hierbei ist eine Spendensumme in Höhe von 4.650,00 Euro zusammengekommen. Wir möchten uns bei allen, die gespendet haben, bedanken und freuen uns, dass wir uns so für einen sehr guten Zweck einbringen konnten." },
    { kind: "paragraph", text: "Anlässlich unserer Spende hat uns der Stiftungsvorstand Oberbürgermeister Frank Rebhan die Dankesurkunde überreicht." }
  ],
};
